import { ENV_URL } from '../enum/env.enum';

const isENv = (env: ENV_URL) => {
  return location.href.includes(env);
};

export const isProd = () => {
  return !(
    isENv(ENV_URL.LOCAL) ||
    isENv(ENV_URL.DEV) ||
    isENv(ENV_URL.PRE_PROD)
  );
};

export const getENV = () => {
  if (isENv(ENV_URL.DEV)) {
    return 'ENV.DEV';
  } else if (isENv(ENV_URL.PRE_PROD)) {
    return 'ENV.PRE_PROD';
  } else if (isENv(ENV_URL.LOCAL)) {
    return 'ENV.LOCAL';
  } else {
    return '';
  }
};
